<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div :class="{modalContent: true, multiple: multiple}">
        <div class="modalHeader">
          <h4>Product Manager</h4>
          <div class="searchCnt">
            <form v-on:submit.prevent="search">
              <input type="text" class="field" placeholder="Search product..."
                v-on:input="search" v-model="query">
              <button></button>
            </form>
          </div>
          <div class="close" v-on:click="close(false)"/>
        </div>
        <div class="modalContentIn loading" v-if="loading"></div>
        <perfect-scrollbar class="modalContentIn qwe" v-else ref="contentCnt">
          <div class="theContainer noData" v-if="!results || results.length <1">
            <div class="noData">
              <img src="../assets/trash-empty.png">
              <h4>Product Empty</h4>
              <p>There is no product found.</p>
            </div>
          </div>
          <div class="theContainer" v-else>
            <div class="imgItem" v-for="(item, index) in results" :key="index"
              v-on:click="close(true, item)">
              <div class="mediaThumb" :style="{'background-image': `url(${item.thumb})`}"
                v-if="item.thumb"></div>
              <div class="mediaThumb noImg" v-else></div>
              <h4>{{item.title}}</h4>
            </div>
          </div>
        </perfect-scrollbar>
        <div class="modalFooter">
          <span>1 media selected</span>
          <div class="btnCnt">
            <button>Cancel</button>
            <button>Insert Media</button>
          </div>
        </div>
      </div>
      <MediaUploader ref="mediaUploader" v-on:close="showMediaUploader = false"
        v-on:ok="uploadOk"/>
    </div>
  </transition>
</template>

<script>
import MediaUploader from '@/components/MediaUploader.vue';

export default {
  props: ['title', 'desc', 'action', 'multiple'],
  components: {
    MediaUploader,
  },
  data() {
    return {
      show: false,
      showMediaUploader: false,
      loading: true,
      results: [],
      data: null,
      next: null,
      page: 0,
      loadingMore: false,
      hasLoadMore: true,
      query: '',
      searchTimer: null,
    };
  },
  methods: {
    open(d, n) {
      this.data = d;
      this.next = n;
      this.show = true;
      this.page = 0;
      this.query = '';
      this.getData();
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') {
        this.next(b, d);
      }
    },
    openMediaUploader() {
      this.$refs.mediaUploader.open({
        type: 'image',
      }, (b, m) => {
        if (b) this.close(b, m);
      });
    },
    uploadOk() {
      this.getData(() => {
        this.showMediaUploader = false;
        this.close(true, this.results[0]);
      });
    },
    loadMore() {
      this.page += 1;
      this.loadingMore = true;
      this.getData();
    },
    search(e) {
      clearTimeout(this.searchTimer);
      this.searchTimer = setTimeout(() => {
        this.getData();
      }, 500);
    },
    getData(next) {
      this.loading = true;
      const uri = `article/all2?parent=products&limit=999&status=published&q=${this.query}`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.results = (r.data.status === 200) ? r.data.data : [];
        this.loading = false;
        if (next) next();
      });
    },
  },
  mounted() {
    // this.getData(null);
  },
};
</script>

<style scoped lang="scss">
  .searchCnt{
    margin-left: 10px;
    height: 35px;
    position: absolute;
    left: 240px;
    top: 8px;
    form{
      position: relative;
      height: 100%;
      input{
        width: 360px;
        height: 100%;
        box-sizing: border-box;
        border: #eee 2px solid;
        background-color: #eee;
        border-radius: 50px;
        font-size: 16px;
        padding: 0 36px 0 14px;
        transition: all .3s ease;
        &:hover{
          border-color: #ccc;
        }
        &:focus{
          background-color: #fff;
          border-color: #0057d8;
          box-shadow: 2px 2px 4px rgba(0,0,0,.2);
        }
      }
      button{
        position: absolute;
        right: 4px; top: 1px;
        width: 33px; height: 33px;
        border-radius: 50%;
        border: none;
        background-color: transparent;
        background-image: url(../assets/search.png);
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
        outline: 0;
        cursor: pointer;
        opacity: .5;
        z-index: 2;
      }
    }
  }

  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    // background-color: rgba(255,255,255,.8);
    // backdrop-filter: saturate(180%) blur(20px);
    .modalContent{
      position: absolute;
      left: 0; top: 0; right: 0; bottom: 0;
      max-width: none;
      margin: 0;
      .modalHeader{
        position: absolute;
        top: 0; left: 0; right: 0; height: 50px;
        padding-left: 20px;
        background-color: #fff;
        .close{
          position: absolute;
          right: 20px;
          top: 9px;
          border-radius: 50%;
          width: 30px; height: 30px;
          background-image: url(../assets/close.png);
          background-size: 12px auto;
          background-repeat: no-repeat;
          background-position: center;
          cursor: pointer;
          &:hover{
            background-color: #eee;
          }
        }
        .upload{
          position: absolute;
          background-color: #fff;
          border: #0057d8 2px solid;
          color: #0057d8;
          right: 60px;
          top: 5px; bottom: 5px;
          line-height: 36px;
          border-radius: 4px;
          padding: 0 20px;
          padding-left: 42px;
          cursor: pointer;
          font-size: 17px;
          font-weight: bold;
          &:before{
            content: "";
            display: block;
            width: 30px; height: 30px;
            left: 10px; top: 3px;
            position: absolute;
            background-image: url(../assets/upload.png);
            background-size: 18px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            background-color: #eee;
          }
        }
        h4{
          margin: 0;
          font-size: 20px;
          line-height: 50px;
        }
      }
      .modalContentIn{
        position: absolute;
        border-top: #eee 1px solid;
        top: 50px; bottom: 0;
        left: 0; right: 0;
        padding: 20px 10px 0;
        background-color: #fff;
        &.loading{
          background-image: url(../assets/loading.svg);
          background-position: center;
          background-repeat: no-repeat;
          background-size: 60px auto;
        }
        .theContainer{
          display: flex;
          flex-wrap: wrap;
          &.noData{
            align-items: center;
            justify-content: center;
            height: 90%;
          }
          .noData{
            text-align: center;
            img{
              display: block;
              height: 260px;
              margin: 0 auto 20px;
            }
            h4{
              margin: 0 0 10px;
              font-weight: 600;
              color: #444;
              font-size: 30px;
            }
            p{
              margin: 0;
              color: #444;
              font-weight: lighter;
            }
          }
          .loadiMore{
            width: auto;
            display: inline-block;
            margin: 0 auto 30px;
            padding: 4px 20px;
            padding-right: 36px;
            background: #0057d8;
            border-radius: 50px;
            color: #fff;
            font-size: 15px;
            cursor: pointer;
            position: relative;
            width: 155px;
            height: 27.5px;
            box-sizing: border-box;
            &.loading{
              background-color: #ddd !important;
              cursor: default;
              background-image: url(../assets/loading.svg);
              background-position: center;
              background-repeat: no-repeat;
              &:before{
                display: none;
              }
              span{
                display: none;
              }
            }
            &:before{
              content: "";
              position: absolute;
              top: 0; right: 16px; bottom: 1px;
              width: 15px;
              background-image: url(../assets/down-arrow-white.png);
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
            }
            &:hover{
              background-color: #0067ff;
            }
          }
          .imgItem{
            width: calc(16.66666% - 20px);
            height: 200px;
            margin: 0 10px 60px;
            cursor: pointer;
            position: relative;
            h4{
              position: absolute;
              margin: 0;
              left: 4px; bottom: -24px; right: 4px;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              font-size: 14px;
              font-weight: 600;
            }

            .mediaThumb{
              position: absolute;
              left: 0; right: 0; top: 0; bottom: 0;
              background-size: contain;
              background-color: #f5f5f5;
              background-position: center;
              background-repeat: no-repeat;
              border-radius: 5px;
              transition: all .16s ease;
              &:hover{
                box-shadow: 2px 2px 6px rgba(0,0,0,.2);
              }
            }
            .delete, .edit{
              width: 30px;
              height: 30px;
              background-color: #fff;
              border-radius: 50%;
              position: absolute;
              z-index: 2;
              right: 10px; top: 10px;
              background-image: url(../assets/delete.png);
              background-size: 18px auto;
              background-position: center;
              background-repeat: no-repeat;
              box-shadow: 2px 2px 4px rgba(0,0,0,.1);
              &:hover{
                cursor: pointer;
                background-color: #ccc;
              }
            }
            .video, .image{
              width: 30px;
              height: 30px;
              background-color: #e21717;
              border-radius: 3px;
              position: absolute;
              z-index: 2;
              bottom: 10px; left: 10px;
              background-image: url(../assets/video.png);
              background-size: 18px auto;
              background-position: center;
              background-repeat: no-repeat;
            }
            .image{
              background-color: #0072ff;
              background-image: url(../assets/photo.png);
            }
            .audio, .processing{
              background-color: #d9d6e4;
              position: absolute;
              left: 0; right: 0; top: 0; bottom: 0;
              display: flex;
              align-items: center;
              justify-content: center;
              text-align: center;
              padding: 0 20px;
              .audioIcon{
                width: 30px;
                height: 30px;
                background-image: url(../assets/musical-note.svg);
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                margin: 0 auto 12px;
              }
              h4{
                margin: 0;
                font-size: 16px;
                line-height: 1.3;
              }
            }
            .processing{
              z-index: 1;
              background: orange !important;
              overflow: hidden;
              display: flex;
              align-items: center;
              justify-content: center;
              span{
                position: relative;
                z-index: 3;
                color: #444;
                font-size: 12px;
                font-size: 24px;
              }
              @-webkit-keyframes MOVE-BG {
                from {
                  -webkit-transform: translateX(0);
                }
                to {
                  -webkit-transform: translateX(46px);
                }
              }
              @keyframes MOVE-BG {
                from {
                  transform: translateX(0);
                }
                to {
                  transform: translateX(46px);
                }
              }
              &:before{
                display: block;
                content: "";
                position: absolute;
                left: -46px;
                right: 0;
                top: 0;
                bottom: 0;
                z-index: 1;
                background: -webkit-repeating-linear-gradient(
                  145deg,
                  rgba(0,0,0,.1) 1px,
                  rgba(0,0,0,0) 2px,
                  rgba(0,0,0,0) 11px,
                  rgba(0,0,0,.1) 12px,
                  rgba(0,0,0,.1) 20px
                );
                background: repeating-linear-gradient(
                  -55deg,
                  rgba(0,0,0,.1) 1px,
                  rgba(0,0,0,0) 2px,
                  rgba(0,0,0,0) 11px,
                  rgba(0,0,0,.1) 12px,
                  rgba(0,0,0,.1) 20px
                );
                -webkit-animation-name: MOVE-BG;
                -webkit-animation-duration: .6s;
                -webkit-animation-timing-function: linear;
                -webkit-animation-iteration-count: infinite;
                animation-name: MOVE-BG;
                animation-duration: .6s;
                animation-timing-function: linear;
                animation-iteration-count: infinite;
              }
            }
            .edit{
              right: 45px;
              background-image: url(../assets/edit.png);
            }

          }
        }
      }
      .modalFooter{
        position: absolute;
        left: 0; right: 0; bottom: 0;
        height: 50px;
        background-color: #fff;
        display: none;
        span{
          display: inline-block;
          line-height: 50px;
          padding-left: 20px;
        }
        .btnCnt{
          float: right;
          padding: 8px 20px 0 0;
          button{
            padding: 10px 20px;
            background-color: #fff;
            border: #999 1px solid;
            border-radius: 4px;
            margin-left: 10px;
            cursor: pointer;
            &:hover{
              box-shadow: 2px 2px 4px rgba(0,0,0,.2);
            }
          }
        }
      }
      &.multiple{
        .modalContentIn{
          bottom: 50px;
        }
        .modalFooter{
          display: block;
        }
      }
    }
  }
</style>
